'use strict';

var map$3 = {};

var map28a001c9 = {};

/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */

/**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */
const create$1 = () => new Map();

/**
 * Copy a Map object into a fresh Map object.
 *
 * @function
 * @template X,Y
 * @param {Map<X,Y>} m
 * @return {Map<X,Y>}
 */
const copy = m => {
  const r = create$1();
  m.forEach((v, k) => { r.set(k, v); });
  return r
};

/**
 * Get map property. Create T if property is undefined and set T on map.
 *
 * ```js
 * const listeners = map.setIfUndefined(events, 'eventName', set.create)
 * listeners.add(listener)
 * ```
 *
 * @function
 * @template T,K
 * @param {Map<K, T>} map
 * @param {K} key
 * @param {function():T} createT
 * @return {T}
 */
const setIfUndefined$1 = (map, key, createT) => {
  let set = map.get(key);
  if (set === undefined) {
    map.set(key, set = createT());
  }
  return set
};

/**
 * Creates an Array and populates it with the content of all key-value pairs using the `f(value, key)` function.
 *
 * @function
 * @template K
 * @template V
 * @template R
 * @param {Map<K,V>} m
 * @param {function(V,K):R} f
 * @return {Array<R>}
 */
const map$2 = (m, f) => {
  const res = [];
  for (const [key, value] of m) {
    res.push(f(value, key));
  }
  return res
};

/**
 * Tests whether any key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @todo should rename to some - similarly to Array.some
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
const any = (m, f) => {
  for (const [key, value] of m) {
    if (f(value, key)) {
      return true
    }
  }
  return false
};

/**
 * Tests whether all key-value pairs pass the test implemented by `f(value, key)`.
 *
 * @function
 * @template K
 * @template V
 * @param {Map<K,V>} m
 * @param {function(V,K):boolean} f
 * @return {boolean}
 */
const all = (m, f) => {
  for (const [key, value] of m) {
    if (!f(value, key)) {
      return false
    }
  }
  return true
};

var map$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create$1,
  copy: copy,
  setIfUndefined: setIfUndefined$1,
  map: map$2,
  any: any,
  all: all
});

map28a001c9.all = all;
map28a001c9.any = any;
map28a001c9.copy = copy;
map28a001c9.create = create$1;
map28a001c9.map = map$2;
map28a001c9.map$1 = map$1$1;
map28a001c9.setIfUndefined = setIfUndefined$1;

Object.defineProperty(map$3, '__esModule', { value: true });

var map$1 = map28a001c9;



map$3.all = map$1.all;
map$3.any = map$1.any;
map$3.copy = map$1.copy;
map$3.create = map$1.create;
map$3.map = map$1.map;
map$3.setIfUndefined = map$1.setIfUndefined;

var random$1 = {};

var math08e068f9 = {};

/**
 * Common Math expressions.
 *
 * @module math
 */

const floor = Math.floor;
const ceil = Math.ceil;
const abs = Math.abs;
const imul = Math.imul;
const round = Math.round;
const log10 = Math.log10;
const log2 = Math.log2;
const log = Math.log;
const sqrt = Math.sqrt;

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The sum of a and b
 */
const add = (a, b) => a + b;

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The smaller element of a and b
 */
const min = (a, b) => a < b ? a : b;

/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The bigger element of a and b
 */
const max = (a, b) => a > b ? a : b;

const isNaN$1 = Number.isNaN;

const pow = Math.pow;
/**
 * Base 10 exponential function. Returns the value of 10 raised to the power of pow.
 *
 * @param {number} exp
 * @return {number}
 */
const exp10 = exp => Math.pow(10, exp);

const sign = Math.sign;

/**
 * @param {number} n
 * @return {boolean} Wether n is negative. This function also differentiates between -0 and +0
 */
const isNegativeZero = n => n !== 0 ? n < 0 : 1 / n < 0;

var math$3 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	floor: floor,
	ceil: ceil,
	abs: abs,
	imul: imul,
	round: round,
	log10: log10,
	log2: log2,
	log: log,
	sqrt: sqrt,
	add: add,
	min: min,
	max: max,
	isNaN: isNaN$1,
	pow: pow,
	exp10: exp10,
	sign: sign,
	isNegativeZero: isNegativeZero
});

math08e068f9.abs = abs;
math08e068f9.add = add;
math08e068f9.ceil = ceil;
math08e068f9.exp10 = exp10;
math08e068f9.floor = floor;
math08e068f9.imul = imul;
math08e068f9.isNaN = isNaN$1;
math08e068f9.isNegativeZero = isNegativeZero;
math08e068f9.log = log;
math08e068f9.log10 = log10;
math08e068f9.log2 = log2;
math08e068f9.math = math$3;
math08e068f9.max = max;
math08e068f9.min = min;
math08e068f9.pow = pow;
math08e068f9.round = round;
math08e068f9.sign = sign;
math08e068f9.sqrt = sqrt;

var browser = {};

/* eslint-env browser */

const perf = typeof performance === 'undefined' ? null : performance;

const isoCrypto = typeof crypto === 'undefined' ? null : crypto;

/**
 * @type {function(number):ArrayBuffer}
 */
const cryptoRandomBuffer = isoCrypto !== null
  ? len => {
    // browser
    const buf = new ArrayBuffer(len);
    const arr = new Uint8Array(buf);
    isoCrypto.getRandomValues(arr);
    return buf
  }
  : len => {
    // polyfill
    const buf = new ArrayBuffer(len);
    const arr = new Uint8Array(buf);
    for (let i = 0; i < len; i++) {
      arr[i] = Math.ceil((Math.random() * 0xFFFFFFFF) >>> 0);
    }
    return buf
  };

browser.performance = perf;
browser.cryptoRandomBuffer = cryptoRandomBuffer;

Object.defineProperty(random$1, '__esModule', { value: true });

var math$2 = math08e068f9;
var isomorphic_js = browser;

const rand = Math.random;

/* istanbul ignore next */
const uint32 = () => new Uint32Array(isomorphic_js.cryptoRandomBuffer(4))[0];

/**
 * @template T
 * @param {Array<T>} arr
 * @return {T}
 */
const oneOf = arr => arr[math$2.floor(rand() * arr.length)];

// @ts-ignore
const uuidv4Template = [1e7] + -1e3 + -4e3 + -8e3 + -1e11;
const uuidv4 = () => uuidv4Template.replace(/[018]/g, /** @param {number} c */ c =>
  (c ^ uint32() & 15 >> c / 4).toString(16)
);

random$1.oneOf = oneOf;
random$1.rand = rand;
random$1.uint32 = uint32;
random$1.uuidv4 = uuidv4;

var set$4 = {};

var set7ae96d21 = {};

/**
 * Utility module to work with sets.
 *
 * @module set
 */

const create = () => new Set();

/**
 * @template T
 * @param {Set<T>} set
 * @return {Array<T>}
 */
const toArray = set => Array.from(set);

var set$3 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	create: create,
	toArray: toArray
});

set7ae96d21.create = create;
set7ae96d21.set = set$3;
set7ae96d21.toArray = toArray;

Object.defineProperty(set$4, '__esModule', { value: true });

var set$2 = set7ae96d21;



set$4.create = set$2.create;
set$4.toArray = set$2.toArray;

var encoding$4 = {};

var bufferAc2cdedf = {};

var stringF3c3d805 = {};

(function (exports) {

/**
 * Utility module to work with strings.
 *
 * @module string
 */

const fromCharCode = String.fromCharCode;
const fromCodePoint = String.fromCodePoint;

/**
 * @param {string} s
 * @return {string}
 */
const toLowerCase = s => s.toLowerCase();

const trimLeftRegex = /^\s*/g;

/**
 * @param {string} s
 * @return {string}
 */
const trimLeft = s => s.replace(trimLeftRegex, '');

const fromCamelCaseRegex = /([A-Z])/g;

/**
 * @param {string} s
 * @param {string} separator
 * @return {string}
 */
const fromCamelCase = (s, separator) => trimLeft(s.replace(fromCamelCaseRegex, match => `${separator}${toLowerCase(match)}`));

/**
 * Compute the utf8ByteLength
 * @param {string} str
 * @return {number}
 */
const utf8ByteLength = str => unescape(encodeURIComponent(str)).length;

/**
 * @param {string} str
 * @return {Uint8Array}
 */
const _encodeUtf8Polyfill = str => {
  const encodedString = unescape(encodeURIComponent(str));
  const len = encodedString.length;
  const buf = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    buf[i] = /** @type {number} */ (encodedString.codePointAt(i));
  }
  return buf
};

/* istanbul ignore next */
const utf8TextEncoder = /** @type {TextEncoder} */ (typeof TextEncoder !== 'undefined' ? new TextEncoder() : null);

/**
 * @param {string} str
 * @return {Uint8Array}
 */
const _encodeUtf8Native = str => utf8TextEncoder.encode(str);

/**
 * @param {string} str
 * @return {Uint8Array}
 */
/* istanbul ignore next */
const encodeUtf8 = utf8TextEncoder ? _encodeUtf8Native : _encodeUtf8Polyfill;

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
const _decodeUtf8Polyfill = buf => {
  let remainingLen = buf.length;
  let encodedString = '';
  let bufPos = 0;
  while (remainingLen > 0) {
    const nextLen = remainingLen < 10000 ? remainingLen : 10000;
    const bytes = buf.subarray(bufPos, bufPos + nextLen);
    bufPos += nextLen;
    // Starting with ES5.1 we can supply a generic array-like object as arguments
    encodedString += String.fromCodePoint.apply(null, /** @type {any} */ (bytes));
    remainingLen -= nextLen;
  }
  return decodeURIComponent(escape(encodedString))
};

/* istanbul ignore next */
exports.utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', { fatal: true, ignoreBOM: true });

/* istanbul ignore next */
if (exports.utf8TextDecoder && exports.utf8TextDecoder.decode(new Uint8Array()).length === 1) {
  // Safari doesn't handle BOM correctly.
  // This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
  // Another issue is that from then on no BOM chars are recognized anymore
  /* istanbul ignore next */
  exports.utf8TextDecoder = null;
}

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
const _decodeUtf8Native = buf => /** @type {TextDecoder} */ (exports.utf8TextDecoder).decode(buf);

/**
 * @param {Uint8Array} buf
 * @return {string}
 */
/* istanbul ignore next */
const decodeUtf8 = exports.utf8TextDecoder ? _decodeUtf8Native : _decodeUtf8Polyfill;

var string = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fromCharCode: fromCharCode,
  fromCodePoint: fromCodePoint,
  trimLeft: trimLeft,
  fromCamelCase: fromCamelCase,
  utf8ByteLength: utf8ByteLength,
  _encodeUtf8Polyfill: _encodeUtf8Polyfill,
  utf8TextEncoder: utf8TextEncoder,
  _encodeUtf8Native: _encodeUtf8Native,
  encodeUtf8: encodeUtf8,
  _decodeUtf8Polyfill: _decodeUtf8Polyfill,
  get utf8TextDecoder () { return exports.utf8TextDecoder; },
  _decodeUtf8Native: _decodeUtf8Native,
  decodeUtf8: decodeUtf8
});

exports._decodeUtf8Native = _decodeUtf8Native;
exports._decodeUtf8Polyfill = _decodeUtf8Polyfill;
exports._encodeUtf8Native = _encodeUtf8Native;
exports._encodeUtf8Polyfill = _encodeUtf8Polyfill;
exports.decodeUtf8 = decodeUtf8;
exports.encodeUtf8 = encodeUtf8;
exports.fromCamelCase = fromCamelCase;
exports.fromCharCode = fromCharCode;
exports.fromCodePoint = fromCodePoint;
exports.string = string;
exports.trimLeft = trimLeft;
exports.utf8ByteLength = utf8ByteLength;
exports.utf8TextEncoder = utf8TextEncoder;

}(stringF3c3d805));

var environment7e2ffaea = {};

var conditionsFb475c70 = {};

/**
 * Often used conditions.
 *
 * @module conditions
 */

/**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */
/* istanbul ignore next */
const undefinedToNull = v => v === undefined ? null : v;

var conditions$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	undefinedToNull: undefinedToNull
});

conditionsFb475c70.conditions = conditions$1;
conditionsFb475c70.undefinedToNull = undefinedToNull;

var storage$1 = {};

Object.defineProperty(storage$1, '__esModule', { value: true });

/* global localStorage, addEventListener */

/**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */

/* istanbul ignore next */
class VarStoragePolyfill {
  constructor () {
    this.map = new Map();
  }

  /**
   * @param {string} key
   * @param {any} newValue
   */
  setItem (key, newValue) {
    this.map.set(key, newValue);
  }

  /**
   * @param {string} key
   */
  getItem (key) {
    return this.map.get(key)
  }
}

/* istanbul ignore next */
/**
 * @type {any}
 */
let _localStorage = new VarStoragePolyfill();
let usePolyfill = true;

try {
  // if the same-origin rule is violated, accessing localStorage might thrown an error
  /* istanbul ignore next */
  if (typeof localStorage !== 'undefined') {
    _localStorage = localStorage;
    usePolyfill = false;
  }
} catch (e) { }

/* istanbul ignore next */
/**
 * This is basically localStorage in browser, or a polyfill in nodejs
 */
const varStorage = _localStorage;

/* istanbul ignore next */
/**
 * A polyfill for `addEventListener('storage', event => {..})` that does nothing if the polyfill is being used.
 *
 * @param {function({ key: string, newValue: string, oldValue: string }): void} eventHandler
 * @function
 */
const onChange = eventHandler => usePolyfill || addEventListener('storage', /** @type {any} */ (eventHandler));

storage$1.onChange = onChange;
storage$1.varStorage = varStorage;

var map = map28a001c9;
var string$1 = stringF3c3d805;
var conditions = conditionsFb475c70;
var storage = storage$1;

/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module map
 */

/* istanbul ignore next */
// @ts-ignore
const isNode = typeof process !== 'undefined' && process.release && /node|io\.js/.test(process.release.name);
/* istanbul ignore next */
const isBrowser = typeof window !== 'undefined' && !isNode;
/* istanbul ignore next */
const isMac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;

/**
 * @type {Map<string,string>}
 */
let params;

/* istanbul ignore next */
const computeParams = () => {
  if (params === undefined) {
    if (isNode) {
      params = map.create();
      const pargs = process.argv;
      let currParamName = null;
      /* istanbul ignore next */
      for (let i = 0; i < pargs.length; i++) {
        const parg = pargs[i];
        if (parg[0] === '-') {
          if (currParamName !== null) {
            params.set(currParamName, '');
          }
          currParamName = parg;
        } else {
          if (currParamName !== null) {
            params.set(currParamName, parg);
            currParamName = null;
          }
        }
      }
      if (currParamName !== null) {
        params.set(currParamName, '');
      }
    // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
    } else if (typeof location === 'object') {
      params = map.create()
      // eslint-disable-next-line no-undef
      ;(location.search || '?').slice(1).split('&').forEach(kv => {
        if (kv.length !== 0) {
          const [key, value] = kv.split('=');
          params.set(`--${string$1.fromCamelCase(key, '-')}`, value);
          params.set(`-${string$1.fromCamelCase(key, '-')}`, value);
        }
      });
    } else {
      params = map.create();
    }
  }
  return params
};

/**
 * @param {string} name
 * @return {boolean}
 */
/* istanbul ignore next */
const hasParam = name => computeParams().has(name);

/**
 * @param {string} name
 * @param {string} defaultVal
 * @return {string}
 */
/* istanbul ignore next */
const getParam = (name, defaultVal) => computeParams().get(name) || defaultVal;
// export const getArgs = name => computeParams() && args

/**
 * @param {string} name
 * @return {string|null}
 */
/* istanbul ignore next */
const getVariable = name => isNode ? conditions.undefinedToNull(process.env[name.toUpperCase()]) : conditions.undefinedToNull(storage.varStorage.getItem(name));

/**
 * @param {string} name
 * @return {string|null}
 */
const getConf = name => computeParams().get('--' + name) || getVariable(name);

/**
 * @param {string} name
 * @return {boolean}
 */
/* istanbul ignore next */
const hasConf = name => hasParam('--' + name) || getVariable(name) !== null;

/* istanbul ignore next */
const production = hasConf('production');

var environment$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isNode: isNode,
  isBrowser: isBrowser,
  isMac: isMac,
  hasParam: hasParam,
  getParam: getParam,
  getVariable: getVariable,
  getConf: getConf,
  hasConf: hasConf,
  production: production
});

environment7e2ffaea.environment = environment$1;
environment7e2ffaea.getConf = getConf;
environment7e2ffaea.getParam = getParam;
environment7e2ffaea.getVariable = getVariable;
environment7e2ffaea.hasConf = hasConf;
environment7e2ffaea.hasParam = hasParam;
environment7e2ffaea.isBrowser = isBrowser;
environment7e2ffaea.isMac = isMac;
environment7e2ffaea.isNode = isNode;
environment7e2ffaea.production = production;

var binaryAc8e39e2 = {};

/* eslint-env browser */

/**
 * Binary data constants.
 *
 * @module binary
 */

/**
 * n-th bit activated.
 *
 * @type {number}
 */
const BIT1 = 1;
const BIT2 = 2;
const BIT3 = 4;
const BIT4 = 8;
const BIT5 = 16;
const BIT6 = 32;
const BIT7 = 64;
const BIT8 = 128;
const BIT9 = 256;
const BIT10 = 512;
const BIT11 = 1024;
const BIT12 = 2048;
const BIT13 = 4096;
const BIT14 = 8192;
const BIT15 = 16384;
const BIT16 = 32768;
const BIT17 = 65536;
const BIT18 = 1 << 17;
const BIT19 = 1 << 18;
const BIT20 = 1 << 19;
const BIT21 = 1 << 20;
const BIT22 = 1 << 21;
const BIT23 = 1 << 22;
const BIT24 = 1 << 23;
const BIT25 = 1 << 24;
const BIT26 = 1 << 25;
const BIT27 = 1 << 26;
const BIT28 = 1 << 27;
const BIT29 = 1 << 28;
const BIT30 = 1 << 29;
const BIT31 = 1 << 30;
const BIT32 = 1 << 31;

/**
 * First n bits activated.
 *
 * @type {number}
 */
const BITS0 = 0;
const BITS1 = 1;
const BITS2 = 3;
const BITS3 = 7;
const BITS4 = 15;
const BITS5 = 31;
const BITS6 = 63;
const BITS7 = 127;
const BITS8 = 255;
const BITS9 = 511;
const BITS10 = 1023;
const BITS11 = 2047;
const BITS12 = 4095;
const BITS13 = 8191;
const BITS14 = 16383;
const BITS15 = 32767;
const BITS16 = 65535;
const BITS17 = BIT18 - 1;
const BITS18 = BIT19 - 1;
const BITS19 = BIT20 - 1;
const BITS20 = BIT21 - 1;
const BITS21 = BIT22 - 1;
const BITS22 = BIT23 - 1;
const BITS23 = BIT24 - 1;
const BITS24 = BIT25 - 1;
const BITS25 = BIT26 - 1;
const BITS26 = BIT27 - 1;
const BITS27 = BIT28 - 1;
const BITS28 = BIT29 - 1;
const BITS29 = BIT30 - 1;
const BITS30 = BIT31 - 1;
/**
 * @type {number}
 */
const BITS31 = 0x7FFFFFFF;
/**
 * @type {number}
 */
const BITS32 = 0xFFFFFFFF;

var binary$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	BIT1: BIT1,
	BIT2: BIT2,
	BIT3: BIT3,
	BIT4: BIT4,
	BIT5: BIT5,
	BIT6: BIT6,
	BIT7: BIT7,
	BIT8: BIT8,
	BIT9: BIT9,
	BIT10: BIT10,
	BIT11: BIT11,
	BIT12: BIT12,
	BIT13: BIT13,
	BIT14: BIT14,
	BIT15: BIT15,
	BIT16: BIT16,
	BIT17: BIT17,
	BIT18: BIT18,
	BIT19: BIT19,
	BIT20: BIT20,
	BIT21: BIT21,
	BIT22: BIT22,
	BIT23: BIT23,
	BIT24: BIT24,
	BIT25: BIT25,
	BIT26: BIT26,
	BIT27: BIT27,
	BIT28: BIT28,
	BIT29: BIT29,
	BIT30: BIT30,
	BIT31: BIT31,
	BIT32: BIT32,
	BITS0: BITS0,
	BITS1: BITS1,
	BITS2: BITS2,
	BITS3: BITS3,
	BITS4: BITS4,
	BITS5: BITS5,
	BITS6: BITS6,
	BITS7: BITS7,
	BITS8: BITS8,
	BITS9: BITS9,
	BITS10: BITS10,
	BITS11: BITS11,
	BITS12: BITS12,
	BITS13: BITS13,
	BITS14: BITS14,
	BITS15: BITS15,
	BITS16: BITS16,
	BITS17: BITS17,
	BITS18: BITS18,
	BITS19: BITS19,
	BITS20: BITS20,
	BITS21: BITS21,
	BITS22: BITS22,
	BITS23: BITS23,
	BITS24: BITS24,
	BITS25: BITS25,
	BITS26: BITS26,
	BITS27: BITS27,
	BITS28: BITS28,
	BITS29: BITS29,
	BITS30: BITS30,
	BITS31: BITS31,
	BITS32: BITS32
});

binaryAc8e39e2.BIT1 = BIT1;
binaryAc8e39e2.BIT10 = BIT10;
binaryAc8e39e2.BIT11 = BIT11;
binaryAc8e39e2.BIT12 = BIT12;
binaryAc8e39e2.BIT13 = BIT13;
binaryAc8e39e2.BIT14 = BIT14;
binaryAc8e39e2.BIT15 = BIT15;
binaryAc8e39e2.BIT16 = BIT16;
binaryAc8e39e2.BIT17 = BIT17;
binaryAc8e39e2.BIT18 = BIT18;
binaryAc8e39e2.BIT19 = BIT19;
binaryAc8e39e2.BIT2 = BIT2;
binaryAc8e39e2.BIT20 = BIT20;
binaryAc8e39e2.BIT21 = BIT21;
binaryAc8e39e2.BIT22 = BIT22;
binaryAc8e39e2.BIT23 = BIT23;
binaryAc8e39e2.BIT24 = BIT24;
binaryAc8e39e2.BIT25 = BIT25;
binaryAc8e39e2.BIT26 = BIT26;
binaryAc8e39e2.BIT27 = BIT27;
binaryAc8e39e2.BIT28 = BIT28;
binaryAc8e39e2.BIT29 = BIT29;
binaryAc8e39e2.BIT3 = BIT3;
binaryAc8e39e2.BIT30 = BIT30;
binaryAc8e39e2.BIT31 = BIT31;
binaryAc8e39e2.BIT32 = BIT32;
binaryAc8e39e2.BIT4 = BIT4;
binaryAc8e39e2.BIT5 = BIT5;
binaryAc8e39e2.BIT6 = BIT6;
binaryAc8e39e2.BIT7 = BIT7;
binaryAc8e39e2.BIT8 = BIT8;
binaryAc8e39e2.BIT9 = BIT9;
binaryAc8e39e2.BITS0 = BITS0;
binaryAc8e39e2.BITS1 = BITS1;
binaryAc8e39e2.BITS10 = BITS10;
binaryAc8e39e2.BITS11 = BITS11;
binaryAc8e39e2.BITS12 = BITS12;
binaryAc8e39e2.BITS13 = BITS13;
binaryAc8e39e2.BITS14 = BITS14;
binaryAc8e39e2.BITS15 = BITS15;
binaryAc8e39e2.BITS16 = BITS16;
binaryAc8e39e2.BITS17 = BITS17;
binaryAc8e39e2.BITS18 = BITS18;
binaryAc8e39e2.BITS19 = BITS19;
binaryAc8e39e2.BITS2 = BITS2;
binaryAc8e39e2.BITS20 = BITS20;
binaryAc8e39e2.BITS21 = BITS21;
binaryAc8e39e2.BITS22 = BITS22;
binaryAc8e39e2.BITS23 = BITS23;
binaryAc8e39e2.BITS24 = BITS24;
binaryAc8e39e2.BITS25 = BITS25;
binaryAc8e39e2.BITS26 = BITS26;
binaryAc8e39e2.BITS27 = BITS27;
binaryAc8e39e2.BITS28 = BITS28;
binaryAc8e39e2.BITS29 = BITS29;
binaryAc8e39e2.BITS3 = BITS3;
binaryAc8e39e2.BITS30 = BITS30;
binaryAc8e39e2.BITS31 = BITS31;
binaryAc8e39e2.BITS32 = BITS32;
binaryAc8e39e2.BITS4 = BITS4;
binaryAc8e39e2.BITS5 = BITS5;
binaryAc8e39e2.BITS6 = BITS6;
binaryAc8e39e2.BITS7 = BITS7;
binaryAc8e39e2.BITS8 = BITS8;
binaryAc8e39e2.BITS9 = BITS9;
binaryAc8e39e2.binary = binary$2;

var number24f1eabe = {};

var math$1 = math08e068f9;
var binary$1 = binaryAc8e39e2;

/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */

const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
const MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER;

const LOWEST_INT32 = 1 << 31;
/**
 * @type {number}
 */
const HIGHEST_INT32 = binary$1.BITS31;

/**
 * @module number
 */

/* istanbul ignore next */
const isInteger = Number.isInteger || (num => typeof num === 'number' && isFinite(num) && math$1.floor(num) === num);
const isNaN = Number.isNaN;

var number$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	MAX_SAFE_INTEGER: MAX_SAFE_INTEGER,
	MIN_SAFE_INTEGER: MIN_SAFE_INTEGER,
	LOWEST_INT32: LOWEST_INT32,
	HIGHEST_INT32: HIGHEST_INT32,
	isInteger: isInteger,
	isNaN: isNaN
});

number24f1eabe.HIGHEST_INT32 = HIGHEST_INT32;
number24f1eabe.LOWEST_INT32 = LOWEST_INT32;
number24f1eabe.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
number24f1eabe.MIN_SAFE_INTEGER = MIN_SAFE_INTEGER;
number24f1eabe.isInteger = isInteger;
number24f1eabe.isNaN = isNaN;
number24f1eabe.number = number$1;

var string = stringF3c3d805;
var environment = environment7e2ffaea;
var binary = binaryAc8e39e2;
var math = math08e068f9;
var number = number24f1eabe;

/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = new encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = new decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */

/**
 * A BinaryEncoder handles the encoding to an Uint8Array.
 */
class Encoder {
  constructor () {
    this.cpos = 0;
    this.cbuf = new Uint8Array(100);
    /**
     * @type {Array<Uint8Array>}
     */
    this.bufs = [];
  }
}

/**
 * @function
 * @return {Encoder}
 */
const createEncoder = () => new Encoder();

/**
 * The current length of the encoded data.
 *
 * @function
 * @param {Encoder} encoder
 * @return {number}
 */
const length = encoder => {
  let len = encoder.cpos;
  for (let i = 0; i < encoder.bufs.length; i++) {
    len += encoder.bufs[i].length;
  }
  return len
};

/**
 * Transform to Uint8Array.
 *
 * @function
 * @param {Encoder} encoder
 * @return {Uint8Array} The created ArrayBuffer.
 */
const toUint8Array = encoder => {
  const uint8arr = new Uint8Array(length(encoder));
  let curPos = 0;
  for (let i = 0; i < encoder.bufs.length; i++) {
    const d = encoder.bufs[i];
    uint8arr.set(d, curPos);
    curPos += d.length;
  }
  uint8arr.set(createUint8ArrayViewFromArrayBuffer(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
  return uint8arr
};

/**
 * Verify that it is possible to write `len` bytes wtihout checking. If
 * necessary, a new Buffer with the required length is attached.
 *
 * @param {Encoder} encoder
 * @param {number} len
 */
const verifyLen = (encoder, len) => {
  const bufferLen = encoder.cbuf.length;
  if (bufferLen - encoder.cpos < len) {
    encoder.bufs.push(createUint8ArrayViewFromArrayBuffer(encoder.cbuf.buffer, 0, encoder.cpos));
    encoder.cbuf = new Uint8Array(math.max(bufferLen, len) * 2);
    encoder.cpos = 0;
  }
};

/**
 * Write one byte to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The byte that is to be encoded.
 */
const write = (encoder, num) => {
  const bufferLen = encoder.cbuf.length;
  if (encoder.cpos === bufferLen) {
    encoder.bufs.push(encoder.cbuf);
    encoder.cbuf = new Uint8Array(bufferLen * 2);
    encoder.cpos = 0;
  }
  encoder.cbuf[encoder.cpos++] = num;
};

/**
 * Write one byte at a specific position.
 * Position must already be written (i.e. encoder.length > pos)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos Position to which to write data
 * @param {number} num Unsigned 8-bit integer
 */
const set$1 = (encoder, pos, num) => {
  let buffer = null;
  // iterate all buffers and adjust position
  for (let i = 0; i < encoder.bufs.length && buffer === null; i++) {
    const b = encoder.bufs[i];
    if (pos < b.length) {
      buffer = b; // found buffer
    } else {
      pos -= b.length;
    }
  }
  if (buffer === null) {
    // use current buffer
    buffer = encoder.cbuf;
  }
  buffer[pos] = num;
};

/**
 * Write one byte as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeUint8 = write;

/**
 * Write one byte as an unsigned Integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
const setUint8 = set$1;

/**
 * Write two bytes as an unsigned integer.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeUint16 = (encoder, num) => {
  write(encoder, num & binary.BITS8);
  write(encoder, (num >>> 8) & binary.BITS8);
};
/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
const setUint16 = (encoder, pos, num) => {
  set$1(encoder, pos, num & binary.BITS8);
  set$1(encoder, pos + 1, (num >>> 8) & binary.BITS8);
};

/**
 * Write two bytes as an unsigned integer
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeUint32 = (encoder, num) => {
  for (let i = 0; i < 4; i++) {
    write(encoder, num & binary.BITS8);
    num >>>= 8;
  }
};

/**
 * Write two bytes as an unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeUint32BigEndian = (encoder, num) => {
  for (let i = 3; i >= 0; i--) {
    write(encoder, (num >>> (8 * i)) & binary.BITS8);
  }
};

/**
 * Write two bytes as an unsigned integer at a specific location.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} pos The location where the data will be written.
 * @param {number} num The number that is to be encoded.
 */
const setUint32 = (encoder, pos, num) => {
  for (let i = 0; i < 4; i++) {
    set$1(encoder, pos + i, num & binary.BITS8);
    num >>>= 8;
  }
};

/**
 * Write a variable length unsigned integer.
 *
 * Encodes integers in the range from [0, 4294967295] / [0, 0xffffffff]. (max 32 bit unsigned integer)
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeVarUint = (encoder, num) => {
  while (num > binary.BITS7) {
    write(encoder, binary.BIT8 | (binary.BITS7 & num));
    num >>>= 7;
  }
  write(encoder, binary.BITS7 & num);
};

/**
 * Write a variable length integer.
 *
 * Encodes integers in the range from [-2147483648, -2147483647].
 *
 * We don't use zig-zag encoding because we want to keep the option open
 * to use the same function for BigInt and 53bit integers (doubles).
 *
 * We use the 7th bit instead for signaling that this is a negative number.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */
const writeVarInt = (encoder, num) => {
  const isNegative = math.isNegativeZero(num);
  if (isNegative) {
    num = -num;
  }
  //             |- whether to continue reading         |- whether is negative     |- number
  write(encoder, (num > binary.BITS6 ? binary.BIT8 : 0) | (isNegative ? binary.BIT7 : 0) | (binary.BITS6 & num));
  num >>>= 6;
  // We don't need to consider the case of num === 0 so we can use a different
  // pattern here than above.
  while (num > 0) {
    write(encoder, (num > binary.BITS7 ? binary.BIT8 : 0) | (binary.BITS7 & num));
    num >>>= 7;
  }
};

/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */
const writeVarString = (encoder, str) => {
  const encodedString = unescape(encodeURIComponent(str));
  const len = encodedString.length;
  writeVarUint(encoder, len);
  for (let i = 0; i < len; i++) {
    write(encoder, /** @type {number} */ (encodedString.codePointAt(i)));
  }
};

/**
 * Write the content of another Encoder.
 *
 * @TODO: can be improved!
 *        - Note: Should consider that when appending a lot of small Encoders, we should rather clone than referencing the old structure.
 *                Encoders start with a rather big initial buffer.
 *
 * @function
 * @param {Encoder} encoder The enUint8Arr
 * @param {Encoder} append The BinaryEncoder to be written.
 */
const writeBinaryEncoder = (encoder, append) => writeUint8Array(encoder, toUint8Array(append));

/**
 * Append fixed-length Uint8Array to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
const writeUint8Array = (encoder, uint8Array) => {
  const bufferLen = encoder.cbuf.length;
  const cpos = encoder.cpos;
  const leftCopyLen = math.min(bufferLen - cpos, uint8Array.length);
  const rightCopyLen = uint8Array.length - leftCopyLen;
  encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
  encoder.cpos += leftCopyLen;
  if (rightCopyLen > 0) {
    // Still something to write, write right half..
    // Append new buffer
    encoder.bufs.push(encoder.cbuf);
    // must have at least size of remaining buffer
    encoder.cbuf = new Uint8Array(math.max(bufferLen * 2, rightCopyLen));
    // copy array
    encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
    encoder.cpos = rightCopyLen;
  }
};

/**
 * Append an Uint8Array to Encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */
const writeVarUint8Array = (encoder, uint8Array) => {
  writeVarUint(encoder, uint8Array.byteLength);
  writeUint8Array(encoder, uint8Array);
};

/**
 * Create an DataView of the next `len` bytes. Use it to write data after
 * calling this function.
 *
 * ```js
 * // write float32 using DataView
 * const dv = writeOnDataView(encoder, 4)
 * dv.setFloat32(0, 1.1)
 * // read float32 using DataView
 * const dv = readFromDataView(encoder, 4)
 * dv.getFloat32(0) // => 1.100000023841858 (leaving it to the reader to find out why this is the correct result)
 * ```
 *
 * @param {Encoder} encoder
 * @param {number} len
 * @return {DataView}
 */
const writeOnDataView = (encoder, len) => {
  verifyLen(encoder, len);
  const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
  encoder.cpos += len;
  return dview
};

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
const writeFloat32 = (encoder, num) => writeOnDataView(encoder, 4).setFloat32(0, num, false);

/**
 * @param {Encoder} encoder
 * @param {number} num
 */
const writeFloat64 = (encoder, num) => writeOnDataView(encoder, 8).setFloat64(0, num, false);

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
const writeBigInt64 = (encoder, num) => /** @type {any} */ (writeOnDataView(encoder, 8)).setBigInt64(0, num, false);

/**
 * @param {Encoder} encoder
 * @param {bigint} num
 */
const writeBigUint64 = (encoder, num) => /** @type {any} */ (writeOnDataView(encoder, 8)).setBigUint64(0, num, false);

const floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */
const isFloat32 = num => {
  floatTestBed.setFloat32(0, num);
  return floatTestBed.getFloat32(0) === num
};

/**
 * Encode data with efficient binary format.
 *
 * Differences to JSON:
 * • Transforms data to a binary format (not to a string)
 * • Encodes undefined, NaN, and ArrayBuffer (these can't be represented in JSON)
 * • Numbers are efficiently encoded either as a variable length integer, as a
 *   32 bit float, as a 64 bit float, or as a 64 bit bigint.
 *
 * Encoding table:
 *
 * | Data Type           | Prefix   | Encoding Method    | Comment |
 * | ------------------- | -------- | ------------------ | ------- |
 * | undefined           | 127      |                    | Functions, symbol, and everything that cannot be identified is encoded as undefined |
 * | null                | 126      |                    | |
 * | integer             | 125      | writeVarInt        | Only encodes 32 bit signed integers |
 * | float32             | 124      | writeFloat32       | |
 * | float64             | 123      | writeFloat64       | |
 * | bigint              | 122      | writeBigInt64      | |
 * | boolean (false)     | 121      |                    | True and false are different data types so we save the following byte |
 * | boolean (true)      | 120      |                    | - 0b01111000 so the last bit determines whether true or false |
 * | string              | 119      | writeVarString     | |
 * | object<string,any>  | 118      | custom             | Writes {length} then {length} key-value pairs |
 * | array<any>          | 117      | custom             | Writes {length} then {length} json values |
 * | Uint8Array          | 116      | writeVarUint8Array | We use Uint8Array for any kind of binary data |
 *
 * Reasons for the decreasing prefix:
 * We need the first bit for extendability (later we may want to encode the
 * prefix with writeVarUint). The remaining 7 bits are divided as follows:
 * [0-30]   the beginning of the data range is used for custom purposes
 *          (defined by the function that uses this library)
 * [31-127] the end of the data range is used for data encoding by
 *          lib0/encoding.js
 *
 * @param {Encoder} encoder
 * @param {undefined|null|number|bigint|boolean|string|Object<string,any>|Array<any>|Uint8Array} data
 */
const writeAny = (encoder, data) => {
  switch (typeof data) {
    case 'string':
      // TYPE 119: STRING
      write(encoder, 119);
      writeVarString(encoder, data);
      break
    case 'number':
      if (number.isInteger(data) && data <= binary.BITS31) {
        // TYPE 125: INTEGER
        write(encoder, 125);
        writeVarInt(encoder, data);
      } else if (isFloat32(data)) {
        // TYPE 124: FLOAT32
        write(encoder, 124);
        writeFloat32(encoder, data);
      } else {
        // TYPE 123: FLOAT64
        write(encoder, 123);
        writeFloat64(encoder, data);
      }
      break
    case 'bigint':
      // TYPE 122: BigInt
      write(encoder, 122);
      writeBigInt64(encoder, data);
      break
    case 'object':
      if (data === null) {
        // TYPE 126: null
        write(encoder, 126);
      } else if (data instanceof Array) {
        // TYPE 117: Array
        write(encoder, 117);
        writeVarUint(encoder, data.length);
        for (let i = 0; i < data.length; i++) {
          writeAny(encoder, data[i]);
        }
      } else if (data instanceof Uint8Array) {
        // TYPE 116: ArrayBuffer
        write(encoder, 116);
        writeVarUint8Array(encoder, data);
      } else {
        // TYPE 118: Object
        write(encoder, 118);
        const keys = Object.keys(data);
        writeVarUint(encoder, keys.length);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          writeVarString(encoder, key);
          writeAny(encoder, data[key]);
        }
      }
      break
    case 'boolean':
      // TYPE 120/121: boolean (true/false)
      write(encoder, data ? 120 : 121);
      break
    default:
      // TYPE 127: undefined
      write(encoder, 127);
  }
};

/**
 * Now come a few stateful encoder that have their own classes.
 */

/**
 * Basic Run Length Encoder - a basic compression implementation.
 *
 * Encodes [1,1,1,7] to [1,3,7,1] (3 times 1, 1 time 7). This encoder might do more harm than good if there are a lot of values that are not repeated.
 *
 * It was originally used for image compression. Cool .. article http://csbruce.com/cbm/transactor/pdfs/trans_v7_i06.pdf
 *
 * @note T must not be null!
 *
 * @template T
 */
class RleEncoder extends Encoder {
  /**
   * @param {function(Encoder, T):void} writer
   */
  constructor (writer) {
    super();
    /**
     * The writer
     */
    this.w = writer;
    /**
     * Current state
     * @type {T|null}
     */
    this.s = null;
    this.count = 0;
  }

  /**
   * @param {T} v
   */
  write (v) {
    if (this.s === v) {
      this.count++;
    } else {
      if (this.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
      }
      this.count = 1;
      // write first value
      this.w(this, v);
      this.s = v;
    }
  }
}

/**
 * Basic diff decoder using variable length encoding.
 *
 * Encodes the values [3, 1100, 1101, 1050, 0] to [3, 1097, 1, -51, -1050] using writeVarInt.
 */
class IntDiffEncoder extends Encoder {
  /**
   * @param {number} start
   */
  constructor (start) {
    super();
    /**
     * Current state
     * @type {number}
     */
    this.s = start;
  }

  /**
   * @param {number} v
   */
  write (v) {
    writeVarInt(this, v - this.s);
    this.s = v;
  }
}

/**
 * A combination of IntDiffEncoder and RleEncoder.
 *
 * Basically first writes the IntDiffEncoder and then counts duplicate diffs using RleEncoding.
 *
 * Encodes the values [1,1,1,2,3,4,5,6] as [1,1,0,2,1,5] (RLE([1,0,0,1,1,1,1,1]) ⇒ RleIntDiff[1,1,0,2,1,5])
 */
class RleIntDiffEncoder extends Encoder {
  /**
   * @param {number} start
   */
  constructor (start) {
    super();
    /**
     * Current state
     * @type {number}
     */
    this.s = start;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  write (v) {
    if (this.s === v && this.count > 0) {
      this.count++;
    } else {
      if (this.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        writeVarUint(this, this.count - 1); // since count is always > 0, we can decrement by one. non-standard encoding ftw
      }
      this.count = 1;
      // write first value
      writeVarInt(this, v - this.s);
      this.s = v;
    }
  }
}

/**
 * @param {UintOptRleEncoder} encoder
 */
const flushUintOptRleEncoder = encoder => {
  /* istanbul ignore else */
  if (encoder.count > 0) {
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set sign to positive
    // case 2: write several values. set sign to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * Optimized Rle encoder that does not suffer from the mentioned problem of the basic Rle encoder.
 *
 * Internally uses VarInt encoder to write unsigned integers. If the input occurs multiple times, we write
 * write it as a negative number. The UintOptRleDecoder then understands that it needs to read a count.
 *
 * Encodes [1,2,3,3,3] as [1,2,-3,3] (once 1, once 2, three times 3)
 */
class UintOptRleEncoder {
  constructor () {
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  write (v) {
    if (this.s === v) {
      this.count++;
    } else {
      flushUintOptRleEncoder(this);
      this.count = 1;
      this.s = v;
    }
  }

  toUint8Array () {
    flushUintOptRleEncoder(this);
    return toUint8Array(this.encoder)
  }
}

/**
 * Increasing Uint Optimized RLE Encoder
 *
 * The RLE encoder counts the number of same occurences of the same value.
 * The IncUintOptRle encoder counts if the value increases.
 * I.e. 7, 8, 9, 10 will be encoded as [-7, 4]. 1, 3, 5 will be encoded
 * as [1, 3, 5].
 */
class IncUintOptRleEncoder {
  constructor () {
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  /**
   * @param {number} v
   */
  write (v) {
    if (this.s + this.count === v) {
      this.count++;
    } else {
      flushUintOptRleEncoder(this);
      this.count = 1;
      this.s = v;
    }
  }

  toUint8Array () {
    flushUintOptRleEncoder(this);
    return toUint8Array(this.encoder)
  }
}

/**
 * @param {IntDiffOptRleEncoder} encoder
 */
const flushIntDiffOptRleEncoder = encoder => {
  if (encoder.count > 0) {
    //          31 bit making up the diff | wether to write the counter
    const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1);
    // flush counter, unless this is the first value (count = 0)
    // case 1: just a single value. set first bit to positive
    // case 2: write several values. set first bit to negative to indicate that there is a length coming
    writeVarInt(encoder.encoder, encodedDiff);
    if (encoder.count > 1) {
      writeVarUint(encoder.encoder, encoder.count - 2); // since count is always > 1, we can decrement by one. non-standard encoding ftw
    }
  }
};

/**
 * A combination of the IntDiffEncoder and the UintOptRleEncoder.
 *
 * The count approach is similar to the UintDiffOptRleEncoder, but instead of using the negative bitflag, it encodes
 * in the LSB whether a count is to be read. Therefore this Encoder only supports 31 bit integers!
 *
 * Encodes [1, 2, 3, 2] as [3, 1, 6, -1] (more specifically [(1 << 1) | 1, (3 << 0) | 0, -1])
 *
 * Internally uses variable length encoding. Contrary to normal UintVar encoding, the first byte contains:
 * * 1 bit that denotes whether the next value is a count (LSB)
 * * 1 bit that denotes whether this value is negative (MSB - 1)
 * * 1 bit that denotes whether to continue reading the variable length integer (MSB)
 *
 * Therefore, only five bits remain to encode diff ranges.
 *
 * Use this Encoder only when appropriate. In most cases, this is probably a bad idea.
 */
class IntDiffOptRleEncoder {
  constructor () {
    this.encoder = new Encoder();
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
    this.diff = 0;
  }

  /**
   * @param {number} v
   */
  write (v) {
    if (this.diff === v - this.s) {
      this.s = v;
      this.count++;
    } else {
      flushIntDiffOptRleEncoder(this);
      this.count = 1;
      this.diff = v - this.s;
      this.s = v;
    }
  }

  toUint8Array () {
    flushIntDiffOptRleEncoder(this);
    return toUint8Array(this.encoder)
  }
}

/**
 * Optimized String Encoder.
 *
 * Encoding many small strings in a simple Encoder is not very efficient. The function call to decode a string takes some time and creates references that must be eventually deleted.
 * In practice, when decoding several million small strings, the GC will kick in more and more often to collect orphaned string objects (or maybe there is another reason?).
 *
 * This string encoder solves the above problem. All strings are concatenated and written as a single string using a single encoding call.
 *
 * The lengths are encoded using a UintOptRleEncoder.
 */
class StringEncoder {
  constructor () {
    /**
     * @type {Array<string>}
     */
    this.sarr = [];
    this.s = '';
    this.lensE = new UintOptRleEncoder();
  }

  /**
   * @param {string} string
   */
  write (string) {
    this.s += string;
    if (this.s.length > 19) {
      this.sarr.push(this.s);
      this.s = '';
    }
    this.lensE.write(string.length);
  }

  toUint8Array () {
    const encoder = new Encoder();
    this.sarr.push(this.s);
    this.s = '';
    writeVarString(encoder, this.sarr.join(''));
    writeUint8Array(encoder, this.lensE.toUint8Array());
    return toUint8Array(encoder)
  }
}

var encoding$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Encoder: Encoder,
  createEncoder: createEncoder,
  length: length,
  toUint8Array: toUint8Array,
  write: write,
  set: set$1,
  writeUint8: writeUint8,
  setUint8: setUint8,
  writeUint16: writeUint16,
  setUint16: setUint16,
  writeUint32: writeUint32,
  writeUint32BigEndian: writeUint32BigEndian,
  setUint32: setUint32,
  writeVarUint: writeVarUint,
  writeVarInt: writeVarInt,
  writeVarString: writeVarString,
  writeBinaryEncoder: writeBinaryEncoder,
  writeUint8Array: writeUint8Array,
  writeVarUint8Array: writeVarUint8Array,
  writeOnDataView: writeOnDataView,
  writeFloat32: writeFloat32,
  writeFloat64: writeFloat64,
  writeBigInt64: writeBigInt64,
  writeBigUint64: writeBigUint64,
  writeAny: writeAny,
  RleEncoder: RleEncoder,
  IntDiffEncoder: IntDiffEncoder,
  RleIntDiffEncoder: RleIntDiffEncoder,
  UintOptRleEncoder: UintOptRleEncoder,
  IncUintOptRleEncoder: IncUintOptRleEncoder,
  IntDiffOptRleEncoder: IntDiffOptRleEncoder,
  StringEncoder: StringEncoder
});

/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = new encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = new decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */

/**
 * A Decoder handles the decoding of an Uint8Array.
 */
class Decoder {
  /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */
  constructor (uint8Array) {
    /**
     * Decoding target.
     *
     * @type {Uint8Array}
     */
    this.arr = uint8Array;
    /**
     * Current decoding position.
     *
     * @type {number}
     */
    this.pos = 0;
  }
}

/**
 * @function
 * @param {Uint8Array} uint8Array
 * @return {Decoder}
 */
const createDecoder = uint8Array => new Decoder(uint8Array);

/**
 * @function
 * @param {Decoder} decoder
 * @return {boolean}
 */
const hasContent = decoder => decoder.pos !== decoder.arr.length;

/**
 * Clone a decoder instance.
 * Optionally set a new position parameter.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} [newPos] Defaults to current position
 * @return {Decoder} A clone of `decoder`
 */
const clone = (decoder, newPos = decoder.pos) => {
  const _decoder = createDecoder(decoder.arr);
  _decoder.pos = newPos;
  return _decoder
};

/**
 * Create an Uint8Array view of the next `len` bytes and advance the position by `len`.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} len The length of bytes to read
 * @return {Uint8Array}
 */
const readUint8Array = (decoder, len) => {
  const view = createUint8ArrayViewFromArrayBuffer(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
  decoder.pos += len;
  return view
};

/**
 * Read variable length Uint8Array.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
const readVarUint8Array = decoder => readUint8Array(decoder, readVarUint(decoder));

/**
 * Read the rest of the content as an ArrayBuffer
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */
const readTailAsUint8Array = decoder => readUint8Array(decoder, decoder.arr.length - decoder.pos);

/**
 * Skip one byte, jump to the next position.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} The next position
 */
const skip8 = decoder => decoder.pos++;

/**
 * Read one byte as unsigned integer.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} Unsigned 8-bit integer
 */
const readUint8 = decoder => decoder.arr[decoder.pos++];

/**
 * Read 2 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const readUint16 = decoder => {
  const uint =
    decoder.arr[decoder.pos] +
    (decoder.arr[decoder.pos + 1] << 8);
  decoder.pos += 2;
  return uint
};

/**
 * Read 4 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const readUint32 = decoder => {
  const uint =
    (decoder.arr[decoder.pos] +
    (decoder.arr[decoder.pos + 1] << 8) +
    (decoder.arr[decoder.pos + 2] << 16) +
    (decoder.arr[decoder.pos + 3] << 24)) >>> 0;
  decoder.pos += 4;
  return uint
};

/**
 * Read 4 bytes as unsigned integer in big endian order.
 * (most significant byte first)
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const readUint32BigEndian = decoder => {
  const uint =
    (decoder.arr[decoder.pos + 3] +
    (decoder.arr[decoder.pos + 2] << 8) +
    (decoder.arr[decoder.pos + 1] << 16) +
    (decoder.arr[decoder.pos] << 24)) >>> 0;
  decoder.pos += 4;
  return uint
};

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const peekUint8 = decoder => decoder.arr[decoder.pos];

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const peekUint16 = decoder =>
  decoder.arr[decoder.pos] +
  (decoder.arr[decoder.pos + 1] << 8);

/**
 * Look ahead without incrementing the position
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */
const peekUint32 = decoder => (
  decoder.arr[decoder.pos] +
  (decoder.arr[decoder.pos + 1] << 8) +
  (decoder.arr[decoder.pos + 2] << 16) +
  (decoder.arr[decoder.pos + 3] << 24)
) >>> 0;

/**
 * Read unsigned integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
const readVarUint = decoder => {
  let num = 0;
  let len = 0;
  while (true) {
    const r = decoder.arr[decoder.pos++];
    num = num | ((r & binary.BITS7) << len);
    len += 7;
    if (r < binary.BIT8) {
      return num >>> 0 // return unsigned number!
    }
    /* istanbul ignore if */
    if (len > 35) {
      throw new Error('Integer out of range!')
    }
  }
};

/**
 * Read signed integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 * @todo This should probably create the inverse ~num if number is negative - but this would be a breaking change.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */
const readVarInt = decoder => {
  let r = decoder.arr[decoder.pos++];
  let num = r & binary.BITS6;
  let len = 6;
  const sign = (r & binary.BIT7) > 0 ? -1 : 1;
  if ((r & binary.BIT8) === 0) {
    // don't continue reading
    return sign * num
  }
  while (true) {
    r = decoder.arr[decoder.pos++];
    num = num | ((r & binary.BITS7) << len);
    len += 7;
    if (r < binary.BIT8) {
      return sign * (num >>> 0)
    }
    /* istanbul ignore if */
    if (len > 41) {
      throw new Error('Integer out of range!')
    }
  }
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
const peekVarUint = decoder => {
  const pos = decoder.pos;
  const s = readVarUint(decoder);
  decoder.pos = pos;
  return s
};

/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */
const peekVarInt = decoder => {
  const pos = decoder.pos;
  const s = readVarInt(decoder);
  decoder.pos = pos;
  return s
};

/**
 * Read string of variable length
 * * varUint is used to store the length of the string
 *
 * Transforming utf8 to a string is pretty expensive. The code performs 10x better
 * when String.fromCodePoint is fed with all characters as arguments.
 * But most environments have a maximum number of arguments per functions.
 * For effiency reasons we apply a maximum of 10000 characters at once.
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String.
 */
const readVarString = decoder => {
  let remainingLen = readVarUint(decoder);
  if (remainingLen === 0) {
    return ''
  } else {
    let encodedString = String.fromCodePoint(readUint8(decoder)); // remember to decrease remainingLen
    if (--remainingLen < 100) { // do not create a Uint8Array for small strings
      while (remainingLen--) {
        encodedString += String.fromCodePoint(readUint8(decoder));
      }
    } else {
      while (remainingLen > 0) {
        const nextLen = remainingLen < 10000 ? remainingLen : 10000;
        // this is dangerous, we create a fresh array view from the existing buffer
        const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
        decoder.pos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, /** @type {any} */ (bytes));
        remainingLen -= nextLen;
      }
    }
    return decodeURIComponent(escape(encodedString))
  }
};

/**
 * Look ahead and read varString without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {string}
 */
const peekVarString = decoder => {
  const pos = decoder.pos;
  const s = readVarString(decoder);
  decoder.pos = pos;
  return s
};

/**
 * @param {Decoder} decoder
 * @param {number} len
 * @return {DataView}
 */
const readFromDataView = (decoder, len) => {
  const dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
  decoder.pos += len;
  return dv
};

/**
 * @param {Decoder} decoder
 */
const readFloat32 = decoder => readFromDataView(decoder, 4).getFloat32(0, false);

/**
 * @param {Decoder} decoder
 */
const readFloat64 = decoder => readFromDataView(decoder, 8).getFloat64(0, false);

/**
 * @param {Decoder} decoder
 */
const readBigInt64 = decoder => /** @type {any} */ (readFromDataView(decoder, 8)).getBigInt64(0, false);

/**
 * @param {Decoder} decoder
 */
const readBigUint64 = decoder => /** @type {any} */ (readFromDataView(decoder, 8)).getBigUint64(0, false);

/**
 * @type {Array<function(Decoder):any>}
 */
const readAnyLookupTable = [
  decoder => undefined, // CASE 127: undefined
  decoder => null, // CASE 126: null
  readVarInt, // CASE 125: integer
  readFloat32, // CASE 124: float32
  readFloat64, // CASE 123: float64
  readBigInt64, // CASE 122: bigint
  decoder => false, // CASE 121: boolean (false)
  decoder => true, // CASE 120: boolean (true)
  readVarString, // CASE 119: string
  decoder => { // CASE 118: object<string,any>
    const len = readVarUint(decoder);
    /**
     * @type {Object<string,any>}
     */
    const obj = {};
    for (let i = 0; i < len; i++) {
      const key = readVarString(decoder);
      obj[key] = readAny(decoder);
    }
    return obj
  },
  decoder => { // CASE 117: array<any>
    const len = readVarUint(decoder);
    const arr = [];
    for (let i = 0; i < len; i++) {
      arr.push(readAny(decoder));
    }
    return arr
  },
  readVarUint8Array // CASE 116: Uint8Array
];

/**
 * @param {Decoder} decoder
 */
const readAny = decoder => readAnyLookupTable[127 - readUint8(decoder)](decoder);

/**
 * T must not be null.
 *
 * @template T
 */
class RleDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */
  constructor (uint8Array, reader) {
    super(uint8Array);
    /**
     * The reader
     */
    this.reader = reader;
    /**
     * Current state
     * @type {T|null}
     */
    this.s = null;
    this.count = 0;
  }

  read () {
    if (this.count === 0) {
      this.s = this.reader(this);
      if (hasContent(this)) {
        this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
      } else {
        this.count = -1; // read the current value forever
      }
    }
    this.count--;
    return /** @type {T} */ (this.s)
  }
}

class IntDiffDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  constructor (uint8Array, start) {
    super(uint8Array);
    /**
     * Current state
     * @type {number}
     */
    this.s = start;
  }

  /**
   * @return {number}
   */
  read () {
    this.s += readVarInt(this);
    return this.s
  }
}

class RleIntDiffDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */
  constructor (uint8Array, start) {
    super(uint8Array);
    /**
     * Current state
     * @type {number}
     */
    this.s = start;
    this.count = 0;
  }

  /**
   * @return {number}
   */
  read () {
    if (this.count === 0) {
      this.s += readVarInt(this);
      if (hasContent(this)) {
        this.count = readVarUint(this) + 1; // see encoder implementation for the reason why this is incremented
      } else {
        this.count = -1; // read the current value forever
      }
    }
    this.count--;
    return /** @type {number} */ (this.s)
  }
}

class UintOptRleDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor (uint8Array) {
    super(uint8Array);
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  read () {
    if (this.count === 0) {
      this.s = readVarInt(this);
      // if the sign is negative, we read the count too, otherwise count is 1
      const isNegative = math.isNegativeZero(this.s);
      this.count = 1;
      if (isNegative) {
        this.s = -this.s;
        this.count = readVarUint(this) + 2;
      }
    }
    this.count--;
    return /** @type {number} */ (this.s)
  }
}

class IncUintOptRleDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor (uint8Array) {
    super(uint8Array);
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
  }

  read () {
    if (this.count === 0) {
      this.s = readVarInt(this);
      // if the sign is negative, we read the count too, otherwise count is 1
      const isNegative = math.isNegativeZero(this.s);
      this.count = 1;
      if (isNegative) {
        this.s = -this.s;
        this.count = readVarUint(this) + 2;
      }
    }
    this.count--;
    return /** @type {number} */ (this.s++)
  }
}

class IntDiffOptRleDecoder extends Decoder {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor (uint8Array) {
    super(uint8Array);
    /**
     * @type {number}
     */
    this.s = 0;
    this.count = 0;
    this.diff = 0;
  }

  /**
   * @return {number}
   */
  read () {
    if (this.count === 0) {
      const diff = readVarInt(this);
      // if the first bit is set, we read more data
      const hasCount = diff & 1;
      this.diff = diff >> 1;
      this.count = 1;
      if (hasCount) {
        this.count = readVarUint(this) + 2;
      }
    }
    this.s += this.diff;
    this.count--;
    return this.s
  }
}

class StringDecoder {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor (uint8Array) {
    this.decoder = new UintOptRleDecoder(uint8Array);
    this.str = readVarString(this.decoder);
    /**
     * @type {number}
     */
    this.spos = 0;
  }

  /**
   * @return {string}
   */
  read () {
    const end = this.spos + this.decoder.read();
    const res = this.str.slice(this.spos, end);
    this.spos = end;
    return res
  }
}

var decoding$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Decoder: Decoder,
  createDecoder: createDecoder,
  hasContent: hasContent,
  clone: clone,
  readUint8Array: readUint8Array,
  readVarUint8Array: readVarUint8Array,
  readTailAsUint8Array: readTailAsUint8Array,
  skip8: skip8,
  readUint8: readUint8,
  readUint16: readUint16,
  readUint32: readUint32,
  readUint32BigEndian: readUint32BigEndian,
  peekUint8: peekUint8,
  peekUint16: peekUint16,
  peekUint32: peekUint32,
  readVarUint: readVarUint,
  readVarInt: readVarInt,
  peekVarUint: peekVarUint,
  peekVarInt: peekVarInt,
  readVarString: readVarString,
  peekVarString: peekVarString,
  readFromDataView: readFromDataView,
  readFloat32: readFloat32,
  readFloat64: readFloat64,
  readBigInt64: readBigInt64,
  readBigUint64: readBigUint64,
  readAny: readAny,
  RleDecoder: RleDecoder,
  IntDiffDecoder: IntDiffDecoder,
  RleIntDiffDecoder: RleIntDiffDecoder,
  UintOptRleDecoder: UintOptRleDecoder,
  IncUintOptRleDecoder: IncUintOptRleDecoder,
  IntDiffOptRleDecoder: IntDiffOptRleDecoder,
  StringDecoder: StringDecoder
});

/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */

/**
 * @param {number} len
 */
const createUint8ArrayFromLen = len => new Uint8Array(len);

/**
 * Create Uint8Array with initial content from buffer
 *
 * @param {ArrayBuffer} buffer
 * @param {number} byteOffset
 * @param {number} length
 */
const createUint8ArrayViewFromArrayBuffer = (buffer, byteOffset, length) => new Uint8Array(buffer, byteOffset, length);

/**
 * Create Uint8Array with initial content from buffer
 *
 * @param {ArrayBuffer} buffer
 */
const createUint8ArrayFromArrayBuffer = buffer => new Uint8Array(buffer);

/* istanbul ignore next */
/**
 * @param {Uint8Array} bytes
 * @return {string}
 */
const toBase64Browser = bytes => {
  let s = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    s += string.fromCharCode(bytes[i]);
  }
  // eslint-disable-next-line no-undef
  return btoa(s)
};

/**
 * @param {Uint8Array} bytes
 * @return {string}
 */
const toBase64Node = bytes => Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString('base64');

/* istanbul ignore next */
/**
 * @param {string} s
 * @return {Uint8Array}
 */
const fromBase64Browser = s => {
  // eslint-disable-next-line no-undef
  const a = atob(s);
  const bytes = createUint8ArrayFromLen(a.length);
  for (let i = 0; i < a.length; i++) {
    bytes[i] = a.charCodeAt(i);
  }
  return bytes
};

/**
 * @param {string} s
 */
const fromBase64Node = s => {
  const buf = Buffer.from(s, 'base64');
  return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength)
};

/* istanbul ignore next */
const toBase64 = environment.isBrowser ? toBase64Browser : toBase64Node;

/* istanbul ignore next */
const fromBase64 = environment.isBrowser ? fromBase64Browser : fromBase64Node;

/**
 * Copy the content of an Uint8Array view to a new ArrayBuffer.
 *
 * @param {Uint8Array} uint8Array
 * @return {Uint8Array}
 */
const copyUint8Array = uint8Array => {
  const newBuf = createUint8ArrayFromLen(uint8Array.byteLength);
  newBuf.set(uint8Array);
  return newBuf
};

/**
 * Encode anything as a UInt8Array. It's a pun on typescripts's `any` type.
 * See encoding.writeAny for more information.
 *
 * @param {any} data
 * @return {Uint8Array}
 */
const encodeAny = data => {
  const encoder = createEncoder();
  writeAny(encoder, data);
  return toUint8Array(encoder)
};

/**
 * Decode an any-encoded value.
 *
 * @param {Uint8Array} buf
 * @return {any}
 */
const decodeAny = buf => readAny(createDecoder(buf));

var buffer = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createUint8ArrayFromLen: createUint8ArrayFromLen,
  createUint8ArrayViewFromArrayBuffer: createUint8ArrayViewFromArrayBuffer,
  createUint8ArrayFromArrayBuffer: createUint8ArrayFromArrayBuffer,
  toBase64: toBase64,
  fromBase64: fromBase64,
  copyUint8Array: copyUint8Array,
  encodeAny: encodeAny,
  decodeAny: decodeAny
});

bufferAc2cdedf.Decoder = Decoder;
bufferAc2cdedf.Encoder = Encoder;
bufferAc2cdedf.IncUintOptRleDecoder = IncUintOptRleDecoder;
bufferAc2cdedf.IncUintOptRleEncoder = IncUintOptRleEncoder;
bufferAc2cdedf.IntDiffDecoder = IntDiffDecoder;
bufferAc2cdedf.IntDiffEncoder = IntDiffEncoder;
bufferAc2cdedf.IntDiffOptRleDecoder = IntDiffOptRleDecoder;
bufferAc2cdedf.IntDiffOptRleEncoder = IntDiffOptRleEncoder;
bufferAc2cdedf.RleDecoder = RleDecoder;
bufferAc2cdedf.RleEncoder = RleEncoder;
bufferAc2cdedf.RleIntDiffDecoder = RleIntDiffDecoder;
bufferAc2cdedf.RleIntDiffEncoder = RleIntDiffEncoder;
bufferAc2cdedf.StringDecoder = StringDecoder;
bufferAc2cdedf.StringEncoder = StringEncoder;
bufferAc2cdedf.UintOptRleDecoder = UintOptRleDecoder;
bufferAc2cdedf.UintOptRleEncoder = UintOptRleEncoder;
bufferAc2cdedf.buffer = buffer;
bufferAc2cdedf.clone = clone;
bufferAc2cdedf.copyUint8Array = copyUint8Array;
bufferAc2cdedf.createDecoder = createDecoder;
bufferAc2cdedf.createEncoder = createEncoder;
bufferAc2cdedf.createUint8ArrayFromArrayBuffer = createUint8ArrayFromArrayBuffer;
bufferAc2cdedf.createUint8ArrayFromLen = createUint8ArrayFromLen;
bufferAc2cdedf.createUint8ArrayViewFromArrayBuffer = createUint8ArrayViewFromArrayBuffer;
bufferAc2cdedf.decodeAny = decodeAny;
bufferAc2cdedf.decoding = decoding$2;
bufferAc2cdedf.encodeAny = encodeAny;
bufferAc2cdedf.encoding = encoding$3;
bufferAc2cdedf.fromBase64 = fromBase64;
bufferAc2cdedf.hasContent = hasContent;
bufferAc2cdedf.length = length;
bufferAc2cdedf.peekUint16 = peekUint16;
bufferAc2cdedf.peekUint32 = peekUint32;
bufferAc2cdedf.peekUint8 = peekUint8;
bufferAc2cdedf.peekVarInt = peekVarInt;
bufferAc2cdedf.peekVarString = peekVarString;
bufferAc2cdedf.peekVarUint = peekVarUint;
bufferAc2cdedf.readAny = readAny;
bufferAc2cdedf.readBigInt64 = readBigInt64;
bufferAc2cdedf.readBigUint64 = readBigUint64;
bufferAc2cdedf.readFloat32 = readFloat32;
bufferAc2cdedf.readFloat64 = readFloat64;
bufferAc2cdedf.readFromDataView = readFromDataView;
bufferAc2cdedf.readTailAsUint8Array = readTailAsUint8Array;
bufferAc2cdedf.readUint16 = readUint16;
bufferAc2cdedf.readUint32 = readUint32;
bufferAc2cdedf.readUint32BigEndian = readUint32BigEndian;
bufferAc2cdedf.readUint8 = readUint8;
bufferAc2cdedf.readUint8Array = readUint8Array;
bufferAc2cdedf.readVarInt = readVarInt;
bufferAc2cdedf.readVarString = readVarString;
bufferAc2cdedf.readVarUint = readVarUint;
bufferAc2cdedf.readVarUint8Array = readVarUint8Array;
bufferAc2cdedf.set = set$1;
bufferAc2cdedf.setUint16 = setUint16;
bufferAc2cdedf.setUint32 = setUint32;
bufferAc2cdedf.setUint8 = setUint8;
bufferAc2cdedf.skip8 = skip8;
bufferAc2cdedf.toBase64 = toBase64;
bufferAc2cdedf.toUint8Array = toUint8Array;
bufferAc2cdedf.write = write;
bufferAc2cdedf.writeAny = writeAny;
bufferAc2cdedf.writeBigInt64 = writeBigInt64;
bufferAc2cdedf.writeBigUint64 = writeBigUint64;
bufferAc2cdedf.writeBinaryEncoder = writeBinaryEncoder;
bufferAc2cdedf.writeFloat32 = writeFloat32;
bufferAc2cdedf.writeFloat64 = writeFloat64;
bufferAc2cdedf.writeOnDataView = writeOnDataView;
bufferAc2cdedf.writeUint16 = writeUint16;
bufferAc2cdedf.writeUint32 = writeUint32;
bufferAc2cdedf.writeUint32BigEndian = writeUint32BigEndian;
bufferAc2cdedf.writeUint8 = writeUint8;
bufferAc2cdedf.writeUint8Array = writeUint8Array;
bufferAc2cdedf.writeVarInt = writeVarInt;
bufferAc2cdedf.writeVarString = writeVarString;
bufferAc2cdedf.writeVarUint = writeVarUint;
bufferAc2cdedf.writeVarUint8Array = writeVarUint8Array;

Object.defineProperty(encoding$4, '__esModule', { value: true });

var encoding$2 = bufferAc2cdedf;











encoding$4.Encoder = encoding$2.Encoder;
encoding$4.IncUintOptRleEncoder = encoding$2.IncUintOptRleEncoder;
encoding$4.IntDiffEncoder = encoding$2.IntDiffEncoder;
encoding$4.IntDiffOptRleEncoder = encoding$2.IntDiffOptRleEncoder;
encoding$4.RleEncoder = encoding$2.RleEncoder;
encoding$4.RleIntDiffEncoder = encoding$2.RleIntDiffEncoder;
encoding$4.StringEncoder = encoding$2.StringEncoder;
encoding$4.UintOptRleEncoder = encoding$2.UintOptRleEncoder;
encoding$4.createEncoder = encoding$2.createEncoder;
encoding$4.length = encoding$2.length;
encoding$4.set = encoding$2.set;
encoding$4.setUint16 = encoding$2.setUint16;
encoding$4.setUint32 = encoding$2.setUint32;
encoding$4.setUint8 = encoding$2.setUint8;
encoding$4.toUint8Array = encoding$2.toUint8Array;
encoding$4.write = encoding$2.write;
encoding$4.writeAny = encoding$2.writeAny;
encoding$4.writeBigInt64 = encoding$2.writeBigInt64;
encoding$4.writeBigUint64 = encoding$2.writeBigUint64;
encoding$4.writeBinaryEncoder = encoding$2.writeBinaryEncoder;
encoding$4.writeFloat32 = encoding$2.writeFloat32;
encoding$4.writeFloat64 = encoding$2.writeFloat64;
encoding$4.writeOnDataView = encoding$2.writeOnDataView;
encoding$4.writeUint16 = encoding$2.writeUint16;
encoding$4.writeUint32 = encoding$2.writeUint32;
encoding$4.writeUint32BigEndian = encoding$2.writeUint32BigEndian;
encoding$4.writeUint8 = encoding$2.writeUint8;
encoding$4.writeUint8Array = encoding$2.writeUint8Array;
encoding$4.writeVarInt = encoding$2.writeVarInt;
encoding$4.writeVarString = encoding$2.writeVarString;
encoding$4.writeVarUint = encoding$2.writeVarUint;
encoding$4.writeVarUint8Array = encoding$2.writeVarUint8Array;

var decoding$1 = {};

Object.defineProperty(decoding$1, '__esModule', { value: true });

var encoding$1 = bufferAc2cdedf;











decoding$1.Decoder = encoding$1.Decoder;
decoding$1.IncUintOptRleDecoder = encoding$1.IncUintOptRleDecoder;
decoding$1.IntDiffDecoder = encoding$1.IntDiffDecoder;
decoding$1.IntDiffOptRleDecoder = encoding$1.IntDiffOptRleDecoder;
decoding$1.RleDecoder = encoding$1.RleDecoder;
decoding$1.RleIntDiffDecoder = encoding$1.RleIntDiffDecoder;
decoding$1.StringDecoder = encoding$1.StringDecoder;
decoding$1.UintOptRleDecoder = encoding$1.UintOptRleDecoder;
decoding$1.clone = encoding$1.clone;
decoding$1.createDecoder = encoding$1.createDecoder;
decoding$1.hasContent = encoding$1.hasContent;
decoding$1.peekUint16 = encoding$1.peekUint16;
decoding$1.peekUint32 = encoding$1.peekUint32;
decoding$1.peekUint8 = encoding$1.peekUint8;
decoding$1.peekVarInt = encoding$1.peekVarInt;
decoding$1.peekVarString = encoding$1.peekVarString;
decoding$1.peekVarUint = encoding$1.peekVarUint;
decoding$1.readAny = encoding$1.readAny;
decoding$1.readBigInt64 = encoding$1.readBigInt64;
decoding$1.readBigUint64 = encoding$1.readBigUint64;
decoding$1.readFloat32 = encoding$1.readFloat32;
decoding$1.readFloat64 = encoding$1.readFloat64;
decoding$1.readFromDataView = encoding$1.readFromDataView;
decoding$1.readTailAsUint8Array = encoding$1.readTailAsUint8Array;
decoding$1.readUint16 = encoding$1.readUint16;
decoding$1.readUint32 = encoding$1.readUint32;
decoding$1.readUint32BigEndian = encoding$1.readUint32BigEndian;
decoding$1.readUint8 = encoding$1.readUint8;
decoding$1.readUint8Array = encoding$1.readUint8Array;
decoding$1.readVarInt = encoding$1.readVarInt;
decoding$1.readVarString = encoding$1.readVarString;
decoding$1.readVarUint = encoding$1.readVarUint;
decoding$1.readVarUint8Array = encoding$1.readVarUint8Array;
decoding$1.skip8 = encoding$1.skip8;

// Similar to a LWW-Element-Set but being a key-value store instead of just unique keys.
// Latest key update is always used, with some conflict resolution when timestamp is equal

const { setIfUndefined } = map$3;
const random = random$1;
const set = set$4;
const encoding = encoding$4;
const decoding = decoding$1;

function CrdtMap (options) {
  const map = new Map();
  const stateVectors = new Map();
  const observers = new Map();
  const subMaps = new Map();
  const localClientId = (options && options.clientId) || random.uint32();

  const clearToTimestamp = (timestamp) => {
    // Clear old removed/tombstoned data
    for (const [key, value] of map.entries()) {
      if (value.data === null && value.timestamp < timestamp) {
        map.delete(key);
      }
    }

    // Clear old state vectors
    for (const [key, vector] of stateVectors.entries()) {
      if (vector < timestamp) {
        stateVectors.delete(key);
      }
    }
  };

  return {
    clientId: localClientId,
    on: function (name, callback) {
      setIfUndefined(observers, name, set.create).add(callback);
    },
    once: function (name, callback) {
      const _f = (...args) => {
        this.off(name, _f);
        callback(...args); // eslint-disable-line node/no-callback-literal
      };
      this.on(name, _f);
    },
    off: function (name, callback) {
      const nameObservers = observers.get(name);
      if (nameObservers != null) {
        nameObservers.delete(callback);
        if (nameObservers.size === 0) {
          observers.delete(name);
        }
      }
    },
    emit: function (name, args) {
      // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
      return Array.from((observers.get(name) || new Map()).values()).forEach(f => f(...args))
    },
    // Returns true if update is applied (i.e. latest data)
    set: function (key, data, timestamp, clientId, emitEvents = true) {
      const existing = map.get(key);

      clientId = clientId == null ? localClientId : clientId;
      timestamp = timestamp == null ? Date.now() : timestamp;

      // Update client state vector
      stateVectors.set(clientId, Math.max(stateVectors.get(clientId) || 0, timestamp));

      if (!existing) {
        map.set(key, { timestamp, data, clientId });
        if (emitEvents) this.emit('update', [{ [key]: { data, timestamp, clientId } }]);
        return true
      }

      // Conflict resolution when removing with same timestamp
      if (data === null && timestamp === existing.timestamp) {
        return false
      }

      // Conflict resolution when adding with same timestamp but different clients
      if (timestamp === existing.timestamp && clientId !== existing.clientId) {
        if (clientId > existing.clientId) {
          map.set(key, { timestamp, data, clientId });
          if (emitEvents) this.emit('update', [{ [key]: { data, timestamp, clientId } }]);
          return true
        }
        return false
      }

      if (timestamp >= existing.timestamp) {
        map.set(key, { timestamp, data, clientId });
        if (emitEvents) this.emit('update', [{ [key]: { data, timestamp, clientId } }]);
        return true
      }

      return false
    },
    remove: function (key, timestamp, clientId) {
      this.set(key, null, timestamp, clientId);
    },
    delete: function (key, timestamp, clientId) {
      this.remove(key, timestamp, clientId);
    },
    has: function (key) {
      return !!this.get(key)
    },
    get: function (key) {
      const data = map.get(key);
      return (data && data.data) || undefined
    },

    // Clear old tombstoned data up to timestamp
    // Will also clear old clientId vectors to make up space
    // Warning! This is potentially dangerous, make sure all data has been synced up to this timestamp
    clearToTimestamp,
    applySnapshot: function (snapshot) {
      const appliedSnapshot = {};
      for (const [key, value] of Object.entries(snapshot)) {
        if (this.set(key, value.data, value.timestamp, value.clientId, false)) {
          appliedSnapshot[key] = value;
        }
      }
      this.emit('snapshot', [snapshot, appliedSnapshot]);
    },
    toJSON: function () {
      const obj = {};

      map.forEach((value, key) => {
        if (value.data !== null) {
          obj[key] = value.data;
        }
      });

      return obj
    },
    getSnapshotFromTimestamp: function (timestamp) {
      const obj = {};

      map.forEach((value, key) => {
        if (value.timestamp >= timestamp) {
          obj[key] = value;
        }
      });

      return obj
    },
    getSnapshotFromStateVectors: function (stateVectors) {
      const obj = {};

      map.forEach((value, key) => {
        const vector = stateVectors[value.clientId];
        if (!vector || value.timestamp > vector) {
          obj[key] = value;
        }
      });

      return obj
    },
    getStateVectors: function () {
      return Object.fromEntries(stateVectors)
    },
    destroy: function () {
      this.emit('destroy', []);
    },
    getMap: function (name) {
      let subMap = subMaps.get(name);
      if (subMap) return subMap

      const prefix = name + ':';

      subMap = {
        set: (key, data, timestamp, clientId) => this.set(prefix + key, data, timestamp, clientId),
        remove: (key, timestamp, clientId) => this.remove(prefix + key, timestamp, clientId),
        delete: (key, timestamp, clientId) => this.remove(prefix + key, timestamp, clientId),
        has: (key) => this.has(prefix + key),
        get: (key) => this.get(prefix + key),
        forEach: (cb) => map.forEach((data, key) => {
          if (data.data && key.startsWith(prefix)) {
            cb(data.data, key.substr(prefix.length));
          }
        }),
        entries: () => {
          const results = [];

          map.forEach((data, key) => {
            if (data.data && key.startsWith(prefix)) {
              results.push([key.substr(prefix.length), data.data]);
            }
          });

          return results
        }
      };
      subMaps.set(name, subMap);

      return subMap
    }
  }
}

CrdtMap.encodeSnapshot = function encodeSnapshot (snapshot) {
  const encoder = encoding.createEncoder();

  for (const [key, value] of Object.entries(snapshot)) {
    if (value.data === null) {
      encoding.writeUint8(encoder, 0);
      encoding.writeVarString(encoder, key);
      encoding.writeFloat64(encoder, value.timestamp);
      encoding.writeUint32(encoder, value.clientId);
    } else {
      encoding.writeUint8(encoder, 1);
      encoding.writeVarString(encoder, key);
      encoding.writeFloat64(encoder, value.timestamp);
      encoding.writeUint32(encoder, value.clientId);
      encoding.writeAny(encoder, value.data);
    }
  }

  return encoding.toUint8Array(encoder)
};

CrdtMap.decodeSnapshot = function decodeSnapshot (byteArray) {
  const decoder = decoding.createDecoder(byteArray);
  const snapshot = {};

  while (decoder.pos < decoder.arr.length) {
    const hasData = decoding.readUint8(decoder) === 1;
    const key = decoding.readVarString(decoder);

    const object = {
      timestamp: decoding.readFloat64(decoder),
      clientId: decoding.readUint32(decoder)
    };

    if (hasData) {
      object.data = decoding.readAny(decoder);
    } else {
      object.data = null;
    }

    snapshot[key] = object;
  }

  return snapshot
};

CrdtMap.encodeStateVectors = function encodeStateVectors (stateVectors) {
  const encoder = encoding.createEncoder();

  for (const [key, vector] of Object.entries(stateVectors)) {
    encoding.writeVarString(encoder, key);
    encoding.writeFloat64(encoder, vector);
  }

  return encoding.toUint8Array(encoder)
};

CrdtMap.decodeStateVectors = function decodeStateVectors (byteArray) {
  const decoder = decoding.createDecoder(byteArray);
  const stateVectors = {};

  while (decoder.pos < decoder.arr.length) {
    const key = decoding.readVarString(decoder);
    const vector = decoding.readFloat64(decoder);

    stateVectors[key] = vector;
  }

  return stateVectors
};

var src = CrdtMap;

module.exports = src;
//# sourceMappingURL=crdtmap.cjs.map
